import script from "./ClubEventTeamEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubEventTeamEdit.vue?vue&type=script&setup=true&lang=js"

import "./ClubEventTeamEdit.vue?vue&type=style&index=0&id=c93de6f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c93de6f0"]])

export default __exports__